(() => {
if (window.__rugGuideV16) return;
window.__rugGuideV16 = true;
const NS = 'http://www.w3.org/2000/svg';
const PRESETS = {
salon: [
{ id: 's2', label: 'Sofa 2-os. · 160 cm', width: 160, depth: 84, seats: 2 },
{ id: 's3', label: 'Sofa 3-os. · 220 cm', width: 220, depth: 90, seats: 3 },
{ id: 'sn', label: 'Narożnik · 260 cm', width: 260, depth: 150, seats: 3 }
],
jadalnia: [
{ id: 't4', label: 'Stół 4 os. · 120 × 80 cm', width: 120, depth: 80, seats: 4 },
{ id: 't6', label: 'Stół 6 os. · 180 × 90 cm', width: 180, depth: 90, seats: 6 },
{ id: 't8', label: 'Stół 8 os. · 220 × 100 cm', width: 220, depth: 100, seats: 8 }
],
sypialnia: [
{ id: 'l90', label: 'Łóżko 90 cm', width: 90, depth: 200 },
{ id: 'l140', label: 'Łóżko 140 cm', width: 140, depth: 200 },
{ id: 'l160', label: 'Łóżko 160 cm', width: 160, depth: 200 },
{ id: 'l180', label: 'Łóżko 180 cm', width: 180, depth: 200 }
]
};
const DEFAULTS = { salon: 's3', jadalnia: 't6', sypialnia: 'l160' };
const one = (root, selector) => root.querySelector(selector);
const all = (root, selector) => Array.from(root.querySelectorAll(selector));
const number = (value, fallback = 0) => {
const parsed = Number(String(value || '').replace(',', '.'));
return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};
const svgNode = (name, attributes = {}, text) => {
const node = document.createElementNS(NS, name);
Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, String(value)));
if (text !== undefined) node.textContent = text;
return node;
};
function setPressed(group, activeButton) {
if (!group || !activeButton) return;
all(group, 'button').forEach((button) => {
const active = button === activeButton;
button.setAttribute('aria-pressed', active ? 'true' : 'false');
if (active) button.setAttribute('aria-current', 'true');
else button.removeAttribute('aria-current');
});
}
function selectedSize(root) {
const button = one(root, '[data-rug-guide-size][aria-pressed="true"]') || one(root, '[data-rug-guide-size]');
if (!button) return { width: 0, depth: 0, label: '', optionId: '' };
const shape = root.dataset.rugShape || 'rectangular';
const label = button.dataset.rugSizeLabel || '';
const values = label.match(/\d+(?:[.,]\d+)?/g) || [];
let width = number(button.dataset.rugWidth);
let depth = number(button.dataset.rugHeight);
const diameter = number(button.dataset.rugDiameter);
if (shape === 'round') {
const size = diameter || number(values[0]);
return { width: size, depth: size, label, optionId: button.dataset.rugSizeOptionId || '' };
}
if (!width || !depth) {
width = number(values[1]);
depth = number(values[0]);
}
if (width < depth) [width, depth] = [depth, width];
return { width, depth, label, optionId: button.dataset.rugSizeOptionId || '' };
}
function selectedPreset(root) {
const zone = root.dataset.zone || 'salon';
const presetId = root.dataset.furniture || DEFAULTS[zone];
return (PRESETS[zone] || []).find((item) => item.id === presetId) || (PRESETS[zone] || [])[0];
}
function room(root) {
return {
width: number(root.dataset.roomWidth, 480),
depth: number(root.dataset.roomDepth, 360)
};
}
function addText(svg, x, y, text, className = 'rg-label', anchor = 'middle') {
svg.append(svgNode('text', { x, y, class: className, 'text-anchor': anchor }, text));
}
function drawSofa(svg, x, y, width, depth, seats) {
svg.append(
svgNode('rect', { x, y, width, height: depth, rx: 2, class: 'rg-furniture' }),
svgNode('rect', { x, y, width, height: Math.min(26, depth * .3), class: 'rg-furniture' })
);
for (let i = 1; i < seats; i += 1) {
const seatX = x + (width * i / seats);
svg.append(svgNode('line', {
x1: seatX,
y1: y + Math.min(26, depth * .3),
x2: seatX,
y2: y + depth,
class: 'rg-furniture-line'
}));
}
}
function drawDining(svg, roomData, preset) {
const tableX = (roomData.width - preset.width) / 2;
const tableY = (roomData.depth - preset.depth) / 2;
const chairW = 38;
const chairD = 36;
const gap = 12;
const topBottom = preset.seats >= 8 ? 3 : preset.seats >= 6 ? 2 : 1;
svg.append(svgNode('rect', { x: tableX, y: tableY, width: preset.width, height: preset.depth, rx: 2, class: 'rg-furniture' }));
for (let i = 0; i < topBottom; i += 1) {
const ratio = topBottom === 1 ? .5 : i / (topBottom - 1);
const x = tableX + (preset.width - chairW) * ratio;
svg.append(
svgNode('rect', { x, y: tableY - chairD - gap, width: chairW, height: chairD, rx: 2, class: 'rg-chair' }),
svgNode('rect', { x, y: tableY + preset.depth + gap, width: chairW, height: chairD, rx: 2, class: 'rg-chair' })
);
}
svg.append(
svgNode('rect', { x: tableX - chairW - gap, y: tableY + (preset.depth - chairD) / 2, width: chairW, height: chairD, rx: 2, class: 'rg-chair' }),
svgNode('rect', { x: tableX + preset.width + gap, y: tableY + (preset.depth - chairD) / 2, width: chairW, height: chairD, rx: 2, class: 'rg-chair' })
);
addText(svg, roomData.width / 2, tableY + preset.depth / 2 + 4, 'Stół', 'rg-label rg-object-label rg-object-label--table');
}
function drawBedroom(svg, roomData, preset) {
const bedX = (roomData.width - preset.width) / 2;
const bedY = 22;
svg.append(
svgNode('rect', { x: bedX, y: bedY, width: preset.width, height: preset.depth, rx: 3, class: 'rg-furniture' }),
svgNode('rect', { x: bedX + 8, y: bedY + 14, width: Math.max(1, preset.width - 16), height: 38, rx: 8, class: 'rg-pillow' })
);
addText(svg, roomData.width / 2, bedY + preset.depth / 2 + 4, 'Łóżko', 'rg-label rg-object-label rg-object-label--bed');
}
function render(root) {
const svg = one(root, '[data-rug-guide-svg]');
if (!svg) return;
const roomData = room(root);
const size = selectedSize(root);
const preset = selectedPreset(root);
const zone = root.dataset.zone || 'salon';
const shape = root.dataset.rugShape || 'rectangular';
const pad = 22;
const footer = 34;
const viewWidth = roomData.width + pad * 2;
const viewHeight = roomData.depth + pad * 2 + footer;
svg.replaceChildren();
svg.setAttribute('viewBox', `0 0 ${viewWidth} ${viewHeight}`);
svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
const roomX = pad;
const roomY = pad;
svg.append(svgNode('rect', { x: roomX, y: roomY, width: roomData.width, height: roomData.depth, class: 'rg-room' }));
let rugWidth = size.width;
let rugDepth = size.depth;
if (zone === 'sypialnia' && shape !== 'round' && rugWidth > rugDepth) [rugWidth, rugDepth] = [rugDepth, rugWidth];
const rugX = roomX + (roomData.width - rugWidth) / 2;
let rugY = roomY + (roomData.depth - rugDepth) / 2;
if (zone === 'salon') rugY = roomY + Math.max(55, roomData.depth - rugDepth - 18);
if (zone === 'sypialnia') rugY = roomY + Math.max(72, roomData.depth - rugDepth - 18);
if (shape === 'round') svg.append(svgNode('circle', { cx: roomX + roomData.width / 2, cy: rugY + rugDepth / 2, r: rugWidth / 2, class: 'rg-rug' }));
else if (shape === 'oval') svg.append(svgNode('ellipse', { cx: roomX + roomData.width / 2, cy: rugY + rugDepth / 2, rx: rugWidth / 2, ry: rugDepth / 2, class: 'rg-rug' }));
else svg.append(svgNode('rect', { x: rugX, y: rugY, width: rugWidth, height: rugDepth, class: 'rg-rug' }));
if (zone === 'salon') {
const sofaX = roomX + (roomData.width - preset.width) / 2;
const sofaY = roomY + 20;
drawSofa(svg, sofaX, sofaY, preset.width, preset.depth, preset.seats || 3);
addText(svg, roomX + roomData.width / 2, sofaY + preset.depth / 2 + 5, preset.id === 'sn' ? 'Narożnik' : 'Sofa', 'rg-label rg-object-label rg-object-label--sofa');
const tableWidth = Math.min(110, rugWidth * .48);
const tableDepth = Math.min(60, rugDepth * .3);
const tableX = roomX + (roomData.width - tableWidth) / 2;
const tableY = rugY + rugDepth * .58 - tableDepth / 2;
svg.append(svgNode('rect', { x: tableX, y: tableY, width: tableWidth, height: tableDepth, rx: 2, class: 'rg-furniture' }));
addText(svg, roomX + roomData.width / 2, tableY + tableDepth / 2 + 4, 'Stolik', 'rg-label rg-object-label rg-object-label--coffee-table');
} else if (zone === 'jadalnia') {
drawDining(svg, { width: roomData.width, depth: roomData.depth }, preset);
Array.from(svg.children).slice(2).forEach((node) => {
if (node.hasAttribute('x')) node.setAttribute('x', Number(node.getAttribute('x')) + roomX);
if (node.hasAttribute('y')) node.setAttribute('y', Number(node.getAttribute('y')) + roomY);
if (node.hasAttribute('x1')) node.setAttribute('x1', Number(node.getAttribute('x1')) + roomX);
if (node.hasAttribute('x2')) node.setAttribute('x2', Number(node.getAttribute('x2')) + roomX);
if (node.hasAttribute('y1')) node.setAttribute('y1', Number(node.getAttribute('y1')) + roomY);
if (node.hasAttribute('y2')) node.setAttribute('y2', Number(node.getAttribute('y2')) + roomY);
});
} else {
const before = svg.children.length;
drawBedroom(svg, { width: roomData.width, depth: roomData.depth }, preset);
Array.from(svg.children).slice(before).forEach((node) => {
if (node.hasAttribute('x')) node.setAttribute('x', Number(node.getAttribute('x')) + roomX);
if (node.hasAttribute('y')) node.setAttribute('y', Number(node.getAttribute('y')) + roomY);
});
}
addText(svg, roomX + roomData.width / 2, roomY + roomData.depth + 24, `Pokój ${roomData.width} × ${roomData.depth} cm`, 'rg-label rg-label--muted');
addText(svg, roomX + roomData.width / 2, Math.min(roomY + roomData.depth - 10, rugY + rugDepth + 18), size.label, 'rg-label');
renderInfo(root, size, preset, zone, { rugWidth, rugDepth });
}
function renderInfo(root, size, preset, zone, oriented) {
const box = one(root, '[data-rug-guide-info]');
if (!box) return;
let verdict = '';
let advice = [];
if (zone === 'salon') {
const margin = Math.round((oriented.rugWidth - preset.width) / 2);
verdict = margin >= 20 ? `Dywan wystaje po około ${margin} cm poza sofę.` : 'Przy tej sofie warto rozważyć większy rozmiar.';
advice = ['Najlepiej, gdy przynajmniej przednie nogi sofy stoją na dywanie.','Zostaw około 20–30 cm dywanu po bokach sofy.'];
} else if (zone === 'jadalnia') {
advice = ['Dywan wyznacza i porządkuje strefę stołu oraz krzeseł.','Zachowaj możliwie równy zapas dywanu z każdej strony stołu.'];
} else {
const margin = Math.round((oriented.rugWidth - preset.width) / 2);
verdict = margin >= 45 ? `Po bokach łóżka pozostaje około ${margin} cm dywanu.` : 'Przy tej szerokości łóżka warto rozważyć większy format.';
advice = ['Zostaw około 45–60 cm widocznego dywanu po bokach łóżka.','Większy format może objąć także przestrzeń przy końcu łóżka.'];
}
const verdictMarkup = verdict ? `<p class="rug-sizeguide__verdict">${verdict}</p>` : '';
box.innerHTML = `${verdictMarkup}<button type="button" class="rug-sizeguide__choose" data-rug-guide-choose>Wybierz rozmiar ${size.label}</button><ul class="rug-sizeguide__advice">${advice.map((item) => `<li>${item}</li>`).join('')}</ul>`;
}
function renderFurnitureButtons(root, keepCurrent = false) {
const zone = root.dataset.zone || 'salon';
const controls = one(root, '[data-rug-furniture-controls]');
const label = one(root, '[data-rug-furniture-label]');
if (!controls || !label) return;
label.textContent = zone === 'salon' ? '2 · Wielkość sofy' : zone === 'jadalnia' ? '2 · Wielkość stołu' : '2 · Szerokość łóżka';
const current = root.dataset.furniture;
const selectedId = keepCurrent && (PRESETS[zone] || []).some((item) => item.id === current) ? current : DEFAULTS[zone];
root.dataset.furniture = selectedId;
controls.replaceChildren(...(PRESETS[zone] || []).map((item) => {
const button = document.createElement('button');
button.type = 'button';
button.textContent = item.label;
button.dataset.rugFurniture = item.id;
button.setAttribute('aria-pressed', item.id === selectedId ? 'true' : 'false');
if (item.id === selectedId) button.setAttribute('aria-current', 'true');
return button;
}));
}
function scrollToVariantPicker() {
const target = document.querySelector('.shopify-section--rug-main-product .rug-size-picker');
if (!target) return;
target.scrollIntoView({ behavior: 'smooth', block: 'start' });
window.setTimeout(() => {
const checked = document.querySelector('.shopify-section--rug-main-product .rug-size-picker__input:checked');
const label = checked && document.querySelector(`label[for="${checked.id}"]`);
if (label && typeof label.focus === 'function') label.focus({ preventScroll: true });
}, 500);
}
function chooseVariant(root) {
const size = selectedSize(root);
if (!size.optionId) return;
const input = all(document, '.shopify-section--rug-main-product .rug-size-picker__input').find((candidate) => candidate.value === size.optionId);
if (!input || input.disabled) return;
if (!input.checked) input.click();
window.setTimeout(scrollToVariantPicker, 80);
window.setTimeout(scrollToVariantPicker, 450);
}
function init(root) {
if (root.dataset.rugGuideReady === 'true') return;
root.dataset.rugGuideReady = 'true';
root.dataset.zone = 'salon';
renderFurnitureButtons(root);
setPressed(one(root, '[data-rug-zone-controls]'), one(root, '[data-rug-guide-zone="salon"]'));
const activeSize = one(root, '[data-rug-guide-size][aria-pressed="true"]') || one(root, '[data-rug-guide-size]');
setPressed(one(root, '[data-rug-size-controls]'), activeSize);
render(root);
}
document.addEventListener('click', (event) => {
const trigger = event.target.closest('[data-rug-dialog-open^="rug-size-guide-"]');
if (!trigger) return;
const targetId = trigger.getAttribute('data-rug-dialog-open');
const target = targetId && document.getElementById(targetId);
if (!target) return;
event.preventDefault();event.stopImmediatePropagation();target.scrollIntoView({ behavior: 'smooth', block: 'start' });
}, true);
document.addEventListener('click', (event) => {
const button = event.target.closest('button');
const root = button && button.closest('[data-rug-guide]');
if (!button || !root) return;
if (button.dataset.rugGuideZone) {root.dataset.zone = button.dataset.rugGuideZone;setPressed(one(root, '[data-rug-zone-controls]'), button);renderFurnitureButtons(root);render(root);return;}
if (button.dataset.rugFurniture) {root.dataset.furniture = button.dataset.rugFurniture;setPressed(one(root, '[data-rug-furniture-controls]'), button);render(root);return;}
if (button.hasAttribute('data-rug-guide-size')) {setPressed(one(root, '[data-rug-size-controls]'), button);render(root);return;}
if (button.hasAttribute('data-rug-guide-choose')) chooseVariant(root);
});
document.addEventListener('variant:change', (event) => {
const title = String(event.detail && event.detail.variant && event.detail.variant.title || '').toLowerCase();
all(document, '[data-rug-guide]').forEach((root) => {
const match = all(root, '[data-rug-guide-size]').find((button) => {const label = String(button.dataset.rugSizeLabel || '').toLowerCase();return label && title.includes(label);});
if (match) {setPressed(one(root, '[data-rug-size-controls]'), match);render(root);}
});
});
document.addEventListener('shopify:section:load', (event) => {all(event.target, '[data-rug-guide]').forEach(init);});
const start = () => all(document, '[data-rug-guide]').forEach(init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
